import React from 'react';
import {
  getOptions,
  coverageFOffered,
  coverageCANotOffered,
  coverageDRNotOffered,
  coverageMINotOffered,
  coverageSTNotOffered,
  coverageSPNotOffered,
  coverageFairRentalNotOffered,
  coverageYardAndGardenNotOffered,
  coverageHomeownerProtectionNotOffered
} from '@ourbranch/lookups';
import Grid from '@material-ui/core/Grid';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { getShowDayCare, getShowSinkhole, getShowOilStorageTank } from 'offer/helpers/get-coverage';
import Field from 'core/components/form/form.v2';
import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { LabelTooltip } from 'core/components/label-tooltip';
import { tooltipHoverTexts } from 'core/helpers/constants';
import { NotificationCard } from 'core/components/notification-card';

import useStyles from '../coverages.styles';

function AdditionalCoverages({ state, id }) {
  const classes = useStyles();

  const offerF = coverageFOffered[state];
  const showCoverageDR = !coverageDRNotOffered[state];
  const showFairRental = !coverageFairRentalNotOffered[state];
  const showYardAndGarden = !coverageYardAndGardenNotOffered[state];
  const showHomeownerProtection = !coverageHomeownerProtectionNotOffered[state];
  const showCoverageCA = !coverageCANotOffered[state];
  const showCoverageMI = !coverageMINotOffered[state];
  const showCoverageST = !coverageSTNotOffered[state];
  const showCoverageSP = !coverageSPNotOffered[state];
  const showDayCare = getShowDayCare(state);
  const showSinkhole = getShowSinkhole(state);
  const showOilStorageTank = getShowOilStorageTank(state);

  return (
    <Grid className={classes.additionalCoverages}>
      <div className={classes.cardSubSectionDivider}>
        <Label type="formSubTitle" className={classes.cardSubSectionTitle}>
          Building coverages
        </Label>

        <Grid container item>
          {offerF && (
            <Field
              id={`${id}.coverageF`}
              name={`${id}.coverageF`}
              type="select"
              label="Fire Department Charges"
              mode="dark"
              options={getOptions('coverageF', state)}
              xs={6}
            />
          )}
          <Grid container>
            {showCoverageDR && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageDR`}
                  name={`${id}.coverageDR`}
                  type="checkbox"
                  label="Electronic Data Recovery"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageDR}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
            <Grid item xs={6}>
              <Field
                id={`${id}.coverageBuildingMaterialsTheft`}
                name={`${id}.coverageBuildingMaterialsTheft`}
                type="checkbox"
                label="Building Materials"
                mode="dark"
                tooltipText={tooltipHoverTexts.coverageBuildingMaterialsTheft}
                tooltipLabel="More Info"
              />
            </Grid>
            {showFairRental && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageFairRental`}
                  name={`${id}.coverageFairRental`}
                  type="checkbox"
                  label="Fair Rental Income"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageFairRental}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
            {showYardAndGarden && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageYardAndGarden`}
                  name={`${id}.coverageYardAndGarden`}
                  type="checkbox"
                  label="Yard and Garden"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageYardAndGarden}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
            <Grid item xs={6}>
              <Field
                id={`${id}.coverageExtendedPremises`}
                name={`${id}.coverageExtendedPremises`}
                type="checkbox"
                label="Extended Premises"
                mode="dark"
                tooltipText={tooltipHoverTexts.coverageExtendedPremises}
                tooltipLabel="More Info"
              />
            </Grid>
            {showHomeownerProtection && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.homeownerProtection`}
                  name={`${id}.homeownerProtection`}
                  type="checkbox"
                  label="Host Protection"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.homeownerProtection}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
            {showDayCare && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageDC`}
                  name={`${id}.coverageDC`}
                  type="checkbox"
                  label="Day Care"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageDC}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}

            {showSinkhole && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageSinkhole`}
                  name={`${id}.coverageSinkhole`}
                  type="checkbox"
                  label="Sinkhole"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageSinkhole}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
            {showOilStorageTank && (
              <Grid item xs={6}>
                <Field
                  id={`${id}.coverageOilStorageTank`}
                  name={`${id}.coverageOilStorageTank`}
                  type="checkbox"
                  label="Oil Storage Tank"
                  mode="dark"
                  tooltipText={tooltipHoverTexts.coverageOilStorageTank}
                  tooltipLabel="More Info"
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        <NotificationCard className={classes.notification} type="infoWhite" noBackground iconSize="icon16">
          <Label className={classes.notificationCardText}>
            Additional included home coverages vary by state and may not be listed here. Refer to your application or
            policy documents for full details.
          </Label>
        </NotificationCard>
      </div>

      <div className={classes.cardSubSectionDivider} spacing={2}>
        <Label type="formSubTitle" className={classes.cardSubSectionTitle}>
          Property Coverages
        </Label>

        <Grid container item spacing={4}>
          <Grid item xs={4}>
            <Field
              id={`${id}.coverageBP`}
              name={`${id}.coverageBP`}
              type="select"
              label="Business Property"
              mode="dark"
              options={getOptions('coverageBP', state)}
            />
          </Grid>

          <Grid item xs={4}>
            <LabelTooltip
              label="Jewelry, Watches, and Furs"
              tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.sppItems }}
            >
              <Field
                id={`${id}.coverageJ`}
                name={`${id}.coverageJ`}
                type="select"
                mode="dark"
                options={getOptions('coverageJ', state)}
              />
            </LabelTooltip>
          </Grid>

          <Grid item xs={4}>
            {showCoverageCA && (
              <LabelTooltip label="Cameras" tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.sppItems }}>
                <Field
                  id={`${id}.coverageCA`}
                  name={`${id}.coverageCA`}
                  type="select"
                  mode="dark"
                  options={getOptions('coverageCA')}
                />
              </LabelTooltip>
            )}
          </Grid>

          <Grid item xs={4}>
            {showCoverageMI && (
              <LabelTooltip
                label="Musical Instruments"
                tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.sppItems }}
              >
                <Field
                  id={`${id}.coverageMI`}
                  name={`${id}.coverageMI`}
                  type="select"
                  mode="dark"
                  options={getOptions('coverageMI', state)}
                />
              </LabelTooltip>
            )}
          </Grid>

          <Grid item xs={4}>
            {showCoverageST && (
              <Field
                id={`${id}.coverageST`}
                name={`${id}.coverageST`}
                type="select"
                label="Silverware Theft"
                mode="dark"
                options={getOptions('coverageST', state)}
              />
            )}
          </Grid>

          <Grid item xs={4}>
            {showCoverageSP && (
              <LabelTooltip
                label="Sports Equipment"
                tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.sppItems }}
              >
                <Field
                  id={`${id}.coverageSP`}
                  name={`${id}.coverageSP`}
                  type="select"
                  mode="dark"
                  options={getOptions('coverageSP', state)}
                />
              </LabelTooltip>
            )}
          </Grid>
        </Grid>

        <NotificationCard type="infoWhite" noBackground iconSize="icon16">
          <>
            <Label className={classes.notificationCardText}>For extended property coverage, add </Label>
            <Button
              className={classes.sppLinkButton}
              type="textSecondary"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('sppContainer').scrollIntoView({ block: 'center', behavior: 'smooth' });
              }}
            >
              <Label>scheduled personal property.</Label>
            </Button>
          </>
        </NotificationCard>
      </div>
    </Grid>
  );
}

AdditionalCoverages.propTypes = {
  id: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired
};

export default observer(AdditionalCoverages);
